module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-button', {
    attrs: {
      "icon": _vm.icon,
      "type": _vm.type,
      "size": _vm.size,
      "loading": _vm.loading,
      "title": _vm.title ? _vm.title : _vm.label,
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.$emit('click', $event)
      }
    }
  }, [_c('span', {
    staticClass: "d-none d-sm-inline d-xl-inline"
  }, [(_vm.icon) ? _c('i', {
    class: _vm.$utilidade.getIcone(_vm.icon)
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.label) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-85152706"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/EdButton.vue
// module id = 1519
// module chunks = 45